const replaceProductCard = () => {
  const wrappers = document.querySelectorAll('[id^="blog-featured-product-pase-wrapper"]');
  wrappers.forEach(wrapper => {
    let product = document.querySelector(`#blog-featured-product-wrapper${idNumber(wrapper.id)}`);
    if (product) {
      let clonedProduct = product.cloneNode(true);
      clonedProduct.id = '';
      wrapper.append(clonedProduct);
    }

  });

  const products = document.querySelectorAll('[id^="blog-featured-product-wrapper"]')
  products.forEach(p => {
    p.remove();
  });

  function idNumber(inputString) {
    const regex = /(\d+)$/;
    const match = inputString.match(regex);
    return match ? parseInt(match[0]) : undefined;
  }

}

replaceProductCard();

